<template>
  <div id="app">
    <router-view v-if="isRouterAlive" :key="approutekey"></router-view>
    <div class="goTop" @click="backTop" v-if="btnFlag">
      <i class="el-icon-caret-top"></i>
    </div>
    <!-- 蓝字补充弹框 -->
    <el-dialog title="提示" :close-on-click-modal="false" :visible.sync="dialogVisible" width="50%">
      <div>
        <div>您好，以下 发票号 存在补传发票或发生其他变动的情况，请及时进行处理：</div>
        <div>{{orderlist.join(",")}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="over" size="small">我已处理，不再提醒</el-button>
        <el-button type="primary" size="small" @click="dealInvoice">马上处理</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  area_list,
  shoppingCartlist,
  copyRight,
  userImgList,
  alertInvoice,
  postClearRedNotice,
  clearInvoice
} from "@/api/xunyou";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
      approutekey: "",
      backTop: this.backTop,
      postAlertInvoice: this.postAlertInvoice
    };
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      isRouterAlive: true,
      btnFlag: false,
      dialogVisible: false,
      orderlist: []
    };
  },
  created() {
    this.$store.dispatch("getNavList"); //获取导航栏列表
    this.$store.dispatch("getAreaList"); //省市区
    this.$store.dispatch("getCategoryList"); //全部商品分类
    if (this.userInfo.userToken) {
      this.postAlertInvoice();
    }
    this.geTCopyright();
    this.getUserImg();
    if (this.userInfo.userId || this.userInfo.userToken) {
      this.getshoppingCartlist(); // 默认代发
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        this.approutekey = (Math.random() * 10000).toFixed(6);
      },
      immediate: true
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    over() {
      this.dialogVisible = false;
      clearInvoice({
        uid: this.userInfo.userId || "",
        userToken: this.userInfo.userToken || "",
        invoiceNumber: ""
      }).then(res => {
        console.log("不再提醒");
      });
    },
    dealInvoice() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.$router.push("/invoiceList?tabs=2");
      }, 200);
    },
    postAlertInvoice() {
      let funUserdata = JSON.parse(localStorage.getItem("userdata")) || {};
      alertInvoice({
        userToken: funUserdata.userToken || "",
        uid: funUserdata.userId || ""
      })
        .then(res => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              this.orderlist = res.data;
              this.dialogVisible = true;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 80) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    backTop() {
      let scrollToptimer = setInterval(function() {
        var top = document.body.scrollTop || document.documentElement.scrollTop;
        var speed = top / 3;
        document.documentElement.scrollTop -= speed;
        if (top < 15) {
          document.documentElement.scrollTop = 0;
          clearInterval(scrollToptimer);
        }
      }, 10);
    },
    // 获取版权名称
    geTCopyright() {
      copyRight()
        .then(res => {
          // console.log(res)
          if (res.code == 0) {
            this.informations = res.rows[0];
            this.setGlobleTitle(this.informations.name || "挪客商城");
            if (this.informations.powstatus == 1) {
              this.$router.push("/erroPage");
            } else {
              this.$store.commit("getcopyRight", this.informations);
            }
          }
        })
        .catch(err => {
          console.log(err);
          // this.$message.error('查询失败,请稍后再试!')
        });
    },
    // 可刷新页面
    // reload(){
    //   this.isRouterAlive = false
    //   this.$nextTick(()=>{
    //     this.isRouterAlive = true
    //   })
    // },
    // 获取所有默认图片
    getUserImg() {
      userImgList().then(res => {
        if (res.code == 0) {
          this.$store.commit("getUserImg", res.rows[0]);
        }
      });
    },
    // 获取购物车
    getshoppingCartlist() {
      let agencyAddressFlag = false; //代发
      if (this.$store.state.shoppingCarNum == "2") {
        agencyAddressFlag = true;
      }
      shoppingCartlist({
        uid: this.userInfo.userId || "",
        userToken: this.userInfo.userToken || "",
        agencyAddressFlag: agencyAddressFlag
      })
        .then(res => {
          //  console.log(res,'购物车');
          if (res.code == "0") {
            this.$store.commit("getCartList", res.data);
          } else {
            if (res.code == "2001") {
              localStorage.removeItem("userdata");
              this.$router.push("/login");
            }
            this.$message({
              message: res.msg,
              type: "warning",
              duration: 2000
            });
          }
        })
        .catch(err => {
          console.log(err);
          // this.$message.error('购物车查询失败，请稍后再试！')
        });
    }
  }
};
</script>

<style>
.mt-8 {
  margin-top: 8px;
}
.mt-20 {
  margin-top: 20px;
}
.mr-6 {
  margin-right: 6px;
}
.goTop {
  position: fixed;
  right: 40px;
  bottom: 20%;
  background-color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #ff6700;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 5;
  &:hover {
    background: rgb(244, 244, 244);
  }
  .el-icon-caret-top {
    font-size: 24px;
  }
}

html,
body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  word-break: break-all;
  padding: 0px;
  margin: 0px;
  min-width: 1200px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-popover.el-popper.backTopBox {
  top: auto !important;
  bottom: 10px;
}

.remarkPopover {
  z-index: 100 !important;
}

.bgfff {
  background: #fff;
}

.myScrollBar {
  max-height: 600px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
  }
}

.preDialog {
  .el-dialog__body {
    padding: 0 20px 0 20px;
    .el-form-item {
      margin-bottom: 8px;
    }
  }
}

.usernameClass {
  min-width: 50px;
  max-width: 300px;
}

.tabPopover {
  max-width: 300px;
}

.nkColor {
  background: #ff6700 !important;
  border-color: #ff6700 !important;
  color: #fff !important;
  &:hover {
    opacity: 0.9 !important;
    color: #fff !important;
  }
}

.nkF56C6C {
  background: #f56c6c !important;
  border-color: #f56c6c !important;
  color: #fff !important;
  &:hover {
    opacity: 0.9 !important;
    color: #fff !important;
  }
}

.nkTheamColor {
  background: #ea0a2a !important;
  border-color: #ea0a2a !important;
  color: #fff !important;
  &:hover {
    opacity: 0.9 !important;
    color: #fff !important;
  }
}

.scienceColor {
  background: #394af8 !important;
  border-color: #394af8 !important;
  color: #fff !important;
  &:hover {
    opacity: 0.9 !important;
    color: #fff !important;
  }
}

.overflowHiden {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.overflowEllipsis {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.plr-10 {
  padding-right: 10px;
  padding-left: 10px;
}

img {
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
</style>


// WEBPACK FOOTER //
// src/App.vue